import React from 'react';
import { BodyText, Button, Tooltip } from '../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

export const HasPermissionButton: React.FC<{
  hasEditPermission: boolean;
  push: (obj: any) => void;
  successMessage: string;
  transferType:
    | 'internal transfers'
    | 'ach deposits'
    | 'check deposits'
    | 'wire deposits'
    | 'automated ACH pushes'
    | 'manual checks';
  defaultObject?: any;
}> = ({ hasEditPermission, push, successMessage, transferType, defaultObject = {} }) =>
  hasEditPermission ? (
    <Button intent={'ghost'} isInline onClick={() => push(defaultObject)} disabled={!hasEditPermission}>
      {successMessage}
    </Button>
  ) : (
    <Tooltip
      placement={'auto'}
      trigger={'hover'}
      tooltipContent={<BodyText>{`You do not have the necessary permissions to edit ${transferType}`}</BodyText>}
    >
      <Button intent={'ghost'} isInline>
        <FontAwesomeIcon icon={faInfoCircle} />
      </Button>
    </Tooltip>
  );
